import React, { Component } from "react";

import { hashHistory } from "react-router";
import { Modal, Header, Input, Table, Divider } from "semantic-ui-react";
import { invformatnumber } from "../../../services/tnminvnumbers";
import Roundy from "../../../services/roundy";
import { grabserviceredux } from "../../../services/crudservice";
import moment from "moment";
class InvoiceSearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      billinginfo: null,
      wod: null,
      resultdrop: "",
      searchVal: "",
      filteroptions: [],
      results: props.workorders,
      showModal: props.showWodSearch,
      datatype: "",
      resultkey: ""
    };
  }
  componentDidMount() {
    grabserviceredux("invoices", "invoices");
  }

  componentDidUpdate(prevProps, prevState) {
    console.log(this.state.searchVal);
    if (
      this.props.showModal &&
      this.props.workorders &&
      !this.state.results.length
    ) {
      this.genresults({ wodparam: "workOrderNbr", service: null });
      this.setState({ results: this.props.invoices });
    }
  }

  genresults() {
    if (this.state.searchVal && this.state.searchVal.length) {
      var keys = Object.keys(this.props.invoices[0]);
      var searchVal = this.state.searchVal.toLowerCase();
      return this.props.invoices.filter(
        inv =>
          inv.workordernumber.toLowerCase().includes(searchVal) ||
          inv.periodbegindate.toLowerCase().includes(searchVal) ||
          inv.description.toLowerCase().includes(searchVal) ||
          inv.periodenddate.toLowerCase().includes(searchVal) ||
          invformatnumber(inv)
            .toLocaleLowerCase()
            .includes(searchVal) ||
          inv.customer.custname.toLowerCase().includes(searchVal)
      );
    } else {
      return this.props.invoices;
    }
  }
  genresultrows() {
    var results = this.genresults();
    return results.map(inv => {
      if (inv.customer) {
        let paid_pct = (inv.paidamount / inv.amount) * 100;
        return (
          <Table.Row
            onClick={() => {
              hashHistory.push("/invlist/" + inv.id);
              this.props.handleclose();
            }}
          >
            <Table.Cell>{invformatnumber(inv)}</Table.Cell>
            <Table.Cell>{inv.workordernumber}</Table.Cell>
            <Table.Cell>{inv.description}</Table.Cell>
            <Table.Cell>{inv.customer.custname}</Table.Cell>
            <Table.Cell>
              {moment(inv.periodbegindate).format("MM/DD/YY")}-{moment(
                inv.periodenddate
              ).format("MM/DD/YY")}
            </Table.Cell>
            <Table.Cell>{Roundy(paid_pct)}%</Table.Cell>
            <Table.Cell>{inv.invcomments}</Table.Cell>
          </Table.Row>
        );
      }
    });
  }
  genresulttable() {
    if (this.props.invoices && this.props.invoices.length > 0) {
      return (
        <Table celled selectable compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Invoice Number</Table.HeaderCell>
              <Table.HeaderCell>Wo Number</Table.HeaderCell>
              <Table.HeaderCell>Description</Table.HeaderCell>
              <Table.HeaderCell>Customer</Table.HeaderCell>
              <Table.HeaderCell>Period</Table.HeaderCell>
              <Table.HeaderCell>Paid Percent</Table.HeaderCell>
              <Table.HeaderCell>Comments</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.genresultrows()}</Table.Body>
        </Table>
      );
    }
  }

  render() {
    return (
      <div className="InvoiceSearchModal">
        <Modal
          open={this.props.showModal}
          size="large"
          onClose={() => {
            this.props.handleclose();
            this.setState(
              { results: this.props.workorders, filteroptions: [] },
              () => this.genresults({ wodparam: "workOrderNbr", service: null })
            );
          }}
        >
          <Header>Find Invoice</Header>
          <Modal.Content>
            <Input
              fluid
              label="Search Invoices"
              value={this.state.searchVal}
              onChange={e => this.setState({ searchVal: e.target.value })}
            />
            <Divider />

            {this.genresulttable()}
          </Modal.Content>
          <Modal.Actions />
        </Modal>
      </div>
    );
  }
}

export default InvoiceSearchModal;



// WEBPACK FOOTER //
// ./src/components/accounting/invoices/invsearchmodal.jsx